import request from '@/utils/request'
import api from '../api'
export class User {
  // retrieve(params) {
  //   return request({
  //     url: api.user.retrieve,
  //     method: 'get',
  //     params
  //   })
  // }
  register(data) {
    return request({
      url: api.user.register,
      method: 'post',
      data
    })
  }
  sendVerifiCode(data) {
    return request({
      url: api.user.sendVerifiCode,
      method: 'post',
      data
    })
  }
  getCodeImgKey(params) {
    return request({
      url: api.user.getCodeImgKey,
      method: 'get',
      params
    })
  }
  getCodeImg(params) {
    return request({
      url: api.user.getCodeImg,
      method: 'get',
      params
    })
  }
  verifyCodeImg(params) {
    return request({
      url: api.user.verifyCodeImg,
      method: 'get',
      params
    })
  }
  logIn(data) {
    return request({
      url: api.user.login,
      method: 'post',
      data
    })
  }
  logout() {
    return request({
      url: api.user.logout,
      method: 'get'
    })
  }
  telRepeat(data) {
    return request({
      url: api.user.telRepeat,
      method: 'post',
      data
    })
  }
}
